export default function partnersNavFilter() {

	let pageUrl = window.location.pathname;
	if(! (pageUrl.indexOf('/partners/') > -1) ) return;
	let shareholdersContainer = document.querySelector('.shareholders__nav');
	if(!shareholdersContainer) return;

	let shareholdersTabs = shareholdersContainer.querySelectorAll('.shareholders__tab');
	let shareholdersTabsArray = [...shareholdersTabs];

	if (pageUrl.indexOf('/loans-documents/') > -1) {
		shareholdersTabsArray.forEach(elem => {
			if ( !(elem.firstChild.href.indexOf('/loans-documents/') > -1) ) {
				elem.remove();
			}
		});
	} else {
		shareholdersTabsArray.forEach(elem => {
			if ( elem.firstChild.href.indexOf('/loans-documents/') > -1 ) {
				elem.remove();
			}
		});
	}
}
